import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-VIP_button_up3",
  "use": "icon-VIP_button_up3-usage",
  "viewBox": "0 0 10 5",
  "content": "<symbol viewBox=\"0 0 10 5\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-VIP_button_up3\"><linearGradient id=\"icon-VIP_button_up3_a\" gradientTransform=\"matrix(1 0 0 -1 0 11)\" gradientUnits=\"userSpaceOnUse\" x1=\"5\" x2=\"5\" y1=\"6.75\" y2=\"10.25\"><stop offset=\"0\" stop-color=\"#f2d9b4\" /><stop offset=\"1\" stop-color=\"#d9b57c\" /></linearGradient><path d=\"m5 .25c-.12 0-.23.04-.33.12l-4 3.5c-.21.18-.23.5-.05.71s.5.23.71.05l3.67-3.21 3.67 3.21c.21.18.52.16.71-.05.18-.21.16-.52-.05-.71l-4-3.5c-.09-.08-.21-.12-.33-.12z\" fill=\"url(#icon-VIP_button_up3_a)\" opacity=\".6\" /><path d=\"m0 0h10v5h-10z\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/VIP_button_up3.svg
// module id = QHmq
// module chunks = 87